import { render } from "./SliderList.vue?vue&type=template&id=af792030&scoped=true"
import script from "./SliderList.vue?vue&type=script&lang=js"
export * from "./SliderList.vue?vue&type=script&lang=js"

import "./SliderList.vue?vue&type=style&index=0&id=af792030&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af792030"]])

export default __exports__